// Paste Formulir Pelanggan — bagian tampilan (editor blok, hasil akhir, data pesanan, peringatan).
export const POS = [["belakang", "Belakang"], ["dada_kiri", "Dada Kiri"], ["dada_kanan", "Dada Kanan"], ["lengan_kiri", "Lengan Kiri"], ["lengan_kanan", "Lengan Kanan"]];
export const LBL = { warna: "Warna Baju", size: "Size", keterangan: "Keterangan Tambahan", ...Object.fromEntries(POS) };
const ST = { terisi: "Terisi", kosong: "Kosong", tidak_disebut: "Tidak disebut", hapus: "Hapus" };

function SizeRows({ sizes, onChange, tid }) {
  const set = (i, k, v) => onChange(sizes.map((s, j) => j === i ? { ...s, [k]: k === "qty" ? (v === "" ? null : Math.max(0, parseInt(v, 10) || 0)) : v } : s));
  return <div className="dfm-sizes">
    {sizes.map((s, i) => <span key={i} className="dfm-size">
      <input value={s.size} onChange={e => set(i, "size", e.target.value.toUpperCase())} aria-label="Ukuran" data-testid={`${tid}-size-${i}`}/>
      <input type="number" min="0" value={s.qty ?? ""} onChange={e => set(i, "qty", e.target.value)} aria-label="Jumlah" data-testid={`${tid}-qty-${i}`}/>
      <button type="button" onClick={() => onChange(sizes.filter((_, j) => j !== i))} aria-label="Hapus baris" data-testid={`${tid}-del-${i}`}>×</button>
    </span>)}
    <button type="button" className="dfm-add" onClick={() => onChange([...sizes, { size: "", qty: 1, color: "" }])} data-testid={`${tid}-add`}>+ Ukuran</button>
  </div>;
}

export function BlockEditor({ block, idx, onChange }) {
  const tid = `dfm-b${idx}`;
  const setF = (f, patch) => onChange({ ...block, [f]: { ...block[f], ...patch } });
  const setText = (f, v) => setF(f, { text: v, status: v.trim() ? (block[f].status === "hapus" ? "hapus" : "terisi") : "kosong" });
  return <fieldset className="dfm-block" data-testid={tid}>
    <legend>Formulir {idx + 1}</legend>
    <label className="dfm-row"><span>Warna Baju</span>
      <input value={block.warna.text} onChange={e => setText("warna", e.target.value)} data-testid={`${tid}-warna`}/></label>
    <div className="dfm-row"><span>Size</span>
      <SizeRows sizes={block.sizes || []} tid={tid} onChange={sizes => onChange({ ...block, sizes, size: { status: sizes.length ? "terisi" : "kosong",
        text: sizes.map(s => `${s.size} ${s.qty ?? ""}`.trim()).join(", ") } })}/></div>
    {POS.map(([f, l]) => <div key={f} className={`dfm-row dfm-st-${block[f].status}`}><span>{l}</span>
      <select value={block[f].status} onChange={e => setF(f, { status: e.target.value })} data-testid={`${tid}-${f}-status`}>
        {Object.entries(ST).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select>
      <input value={block[f].status === "hapus" ? "" : block[f].text} disabled={block[f].status === "hapus"} placeholder={block[f].status === "hapus" ? "Instruksi lama akan dihapus" : ""}
        onChange={e => setText(f, e.target.value)} data-testid={`${tid}-${f}`}/></div>)}
    <label className="dfm-row"><span>Keterangan</span>
      <textarea rows={2} value={block.keterangan.text} onChange={e => setText("keterangan", e.target.value)} data-testid={`${tid}-keterangan`}/></label>
  </fieldset>;
}

export function ResultView({ final }) {
  return <div className="dfm-result" data-testid="dfm-result">
    {final.map((b, i) => <div key={i} className="dfm-result-card" data-testid={`dfm-result-${i}`}>
      <b>{b.warna.text || "Warna belum diisi"}</b>
      <span>Size: {(b.sizes || []).map(s => `${s.size}×${s.qty ?? "?"}`).join(", ") || "—"}</span>
      {POS.filter(([f]) => b[f].status === "terisi").map(([f, l]) => <span key={f}>{l}: {b[f].text}</span>)}
      {b.keterangan.status === "terisi" && <span>Ket: {b.keterangan.text}</span>}
    </div>)}
  </div>;
}

export function NeedTable({ lines }) {
  if (!lines?.length) return <p className="dfm-muted" data-testid="dfm-need-empty">Data item pesanan belum tersedia.</p>;
  return <table className="dfm-need" data-testid="dfm-need"><thead><tr><th>Produk</th><th>Bahan/Lengan</th><th>Warna</th><th>Size</th><th>Qty</th></tr></thead>
    <tbody>{lines.map((l, i) => <tr key={i}><td>{l.product}</td><td>{[l.material, l.sleeve].filter(Boolean).join(" · ") || "—"}</td>
      <td>{l.color || "—"}</td><td>{l.size || l.variation_raw || "—"}</td><td>{l.qty}</td></tr>)}</tbody></table>;
}

export function Warnings({ items }) {
  if (!items?.length) return <p className="dfm-ok" data-testid="dfm-no-warn">Cocok dengan data pesanan.</p>;
  return <ul className="dfm-warn" data-testid="dfm-warnings">{items.map((w, i) =>
    <li key={i} className={`is-${w.level}`} data-testid={`dfm-warn-${w.code}`}>{w.msg}</li>)}</ul>;
}

export function Removals({ items, checked, onCheck }) {
  if (!items.length) return null;
  return <div className="dfm-removal" data-testid="dfm-removals">
    <b>Instruksi lama yang akan dihapus/dikosongkan:</b>
    <ul>{items.map((r, i) => <li key={i}>Formulir {r.block + 1} · {LBL[r.field] || r.field}: <s>{r.old}</s></li>)}</ul>
    <label><input type="checkbox" checked={checked} onChange={e => onCheck(e.target.checked)} data-testid="dfm-confirm-removals"/> Saya yakin menghapus instruksi lama di atas</label>
  </div>;
}
